/**
 * Time helpers for event labels and optional video playback ranges.
 */
export function formatEventTime(event) {
  return event.originalTime || `${event.timestamp}`
}

export function parseTimeToSeconds(timeStr) {
  if (!timeStr) return 0
  const parts = timeStr.split(':')
  if (parts.length !== 3) return 0
  const [hh, mm, ss] = parts
  return (
    parseInt(hh, 10) * 3600 +
    parseInt(mm, 10) * 60 +
    parseFloat(ss.replace(',', '.'))
  )
}

export function getVideoClipRangeFromEvent(eventObj, rangeSec = 5) {
  const center = parseTimeToSeconds(eventObj.originalTime)
  return {
    start: Math.max(center - rangeSec, 0),
    end: center + rangeSec,
  }
}
